// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".module-box[data-v-27702db4]{border-radius:.24rem;margin-bottom:.36rem}.title-box[data-v-27702db4]{position:relative;display:flex;justify-content:center;align-items:center;z-index:2;text-align:center}.title-box img[data-v-27702db4]{display:inline-block;vertical-align:middle;margin-top:-.04rem}.title-left[data-v-27702db4]{width:.6rem}.title[data-v-27702db4]{position:relative;margin:0 .41rem;z-index:2;white-space:nowrap;color:#1a1a1a;font-size:.28rem;font-weight:700}", ""]);
// Exports
module.exports = exports;
